import { render, staticRenderFns } from "./Usuarios.vue?vue&type=template&id=8b32c3dc&scoped=true&dark=true"
import script from "./Usuarios.vue?vue&type=script&lang=js"
export * from "./Usuarios.vue?vue&type=script&lang=js"
import style0 from "./Usuarios.vue?vue&type=style&index=0&id=8b32c3dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b32c3dc",
  null
  
)

export default component.exports